import { t } from "@/i18n-js/instance";
import { Collapsible } from "@circle-react-uikit/Collapsible";
import { BorderRadiusSelector } from "../../../../Editor/fields/BorderRadius";
import type { ButtonVariant } from "./ButtonStateSelector";
import { generateFormItemName } from "./Styles";
import type { ButtonType } from "./constants";

interface CornersProps {
  buttonType: ButtonType;
  selectedButtonVariant: ButtonVariant;
}
export const Corners = ({
  selectedButtonVariant,
  buttonType,
}: CornersProps) => (
  <Collapsible title={t("builder_ui.prop_type.styles.corners")} defaultOpen>
    <div className="space-y-4 px-6 py-5">
      <BorderRadiusSelector
        name={generateFormItemName(
          buttonType,
          selectedButtonVariant,
          "borderRadius",
        )}
      />
    </div>
  </Collapsible>
);
